import { useState } from 'react';
import { ElvyraChatPanel } from './elvyra-chat-panel';

export function ElvyraFAB() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating Action Button */}
      <button
        onClick={() => setOpen(o => !o)}
        className="fixed bottom-6 right-6 z-[200] w-14 h-14 rounded-full bg-accent shadow-lg shadow-accent/20 flex items-center justify-center group hover:bg-accent-bright transition-colors focus:outline-none focus:ring-2 focus:ring-accent-bright focus:ring-offset-2 focus:ring-offset-bg"
        aria-label={open ? 'Close Elvyra' : 'Open Elvyra'}
        aria-expanded={open}
      >
        <div className="absolute inset-0 rounded-full animate-[pulse-ring_2s_ease-in-out_infinite] border-2 border-accent opacity-30" />
        <span className="font-display text-lg font-bold text-white select-none">E</span>
      </button>

      {/* Chat Panel */}
      {open && (
        <ElvyraChatPanel onClose={() => setOpen(false)} />
      )}
    </>
  );
}
